import axios from "axios"

const api = axios.create({
  // Internal Server
  // baseURL: 'http://206.189.141.125:8088/api/v1',
  // baseURL: 'https://alphaapi.mequalsvps.in/api/v1',
  // baseURL: 'http://159.65.150.191:3000/api/v1',

  // Demo alpha One 
  //Demo Build
   //baseURL: "https://demoapi.alphaone.app/api/v1",

  //baseURL: 'http://localhost:3000/api/v1',

  //HRMS live alpha One

  // baseURL: "https://hrmsapi.alphaone.app/api/v1",
  // api demo alpha One
  //Live Build
  baseURL: "https://api.alphaone.app/api/v1",
  timeout: 250000,
  //  headers: { Accept: "application/json" },
})

export function setAuthToken(authToken) {
  api.defaults.headers.common["Authorization"] = authToken
}

export default api

export function uploadFile(uploadUrl, data, contentType) {
  return axios
    .put(uploadUrl, data, {
      headers: {
        Accept: "application/json",
        "Content-Type": contentType,
      },
    })
    .then((response) => response.data)
}
